import { Component, Input } from '@angular/core';

@Component({
  selector: 'std-loader',
  template: `
    <div
      class="fixed top-0 z-[100000] left-0 w-screen h-screen bg-black !bg-opacity-25 flex items-center justify-center"
      >
      <!-- <div
        [class]="
          'h-32 w-32 animate-spin border-[6px] border-t-[var(--primary)]  rounded-full ' +
          customClass
        "
        >
        @if (img) {
          <img class="h-32 w-32" [src]="img" [class]="imgClass" />
        }
      </div> -->
      <div class="relative h-[80px] w-[222px] animate-bounce mx-auto">
            <img class="h-[80px] w-[222px] absolute left-0 top-0 opacity-50" src="./assets/logo.png">
            <div class="h-[80px] w-[0px] absolute left-0 top-0 overflow-hidden loader-animation">
                <div style="background: url(./assets/logo.png);background-size: 100%;" class="h-[80px] w-[222px] bg-no-repeat absolute left-0"></div>
            </div>
        </div>
    </div>
    `,
  styles: [],
  standalone: false,
})
export class LoaderComponent {
  constructor() {}
  @Input() img!: string;
  @Input() imgClass = '';
  @Input() customClass: string = '';
}
